module.exports = __webpack_public_path__ + "img/img_promotion_01_500_m_tv.78aacd35.png";